import type { FC, PropsWithChildren } from "react";
import React from "react";

import { decodeJwtPayload } from "@core/foundation/jwt";
import { FetchApiClient } from "@core/ports/http";

import { UserClaimsSchema } from "@platform/core/models";

import { calorieGridApi } from "@apis/calorie-grid/api";

import { env } from "../../../bootstrap/env.ts";
import type { AuthContextValue } from "../../../shared/contexts/auth/context.ts";
import { AuthContext } from "../../../shared/contexts/auth/context.ts";
import { authStore } from "../state/auth.ts";

interface AuthProviderProps {
  readonly authToken: string;
}

export const AuthProvider: FC<PropsWithChildren<AuthProviderProps>> = ({
  authToken,
  children,
}) => {
  const userClaims = UserClaimsSchema.parse(decodeJwtPayload(authToken));
  const value: AuthContextValue = {
    api: {
      calorieGrid: new FetchApiClient({
        api: calorieGridApi,
        getToken: () => authToken,
        onUnauthorized: authStore.clearToken,
        stage: env.STAGE,
      }).getApi(),
    },
    userId: userClaims.id,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
